import React from "react";
import { cn } from "@/lib/utils";
import {
  Control,
  FieldPath,
  FieldValues,
  useController,
} from "react-hook-form";

interface CheckboxProps<
  TFieldValues extends FieldValues = FieldValues,
  TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>,
> {
  label: string;
  id: string;
  name: TName;
  classNames?: string;
  control?: Control<TFieldValues>;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

export default function Checkbox<
  TFieldValues extends FieldValues = FieldValues,
  TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>,
>({
  label,
  id,
  name,
  classNames,
  control,
  onChange,
}: CheckboxProps<TFieldValues, TName>) {
  const { field } = useController({
    name,
    control,
  });
  return (
    <div className="flex flex-row items-center">
      <div className="flex h-5 items-center">
        <input
          id={id}
          name={name}
          type="checkbox"
          checked={!!field.value}
          className="h-4 w-4 cursor-pointer rounded border-gray-300 text-black focus:ring-black"
          onChange={onChange}
        />
      </div>
      <div className={cn("ml-3 text-xs", classNames)}>
        <label
          htmlFor={id}
          className="cursor-pointer font-medium text-gray-700"
        >
          {label}
        </label>
      </div>
    </div>
  );
}
